module.exports = __webpack_public_path__ + "img/Meet-The-Team.0528a472.png";